import { defaultLocale } from '../../settings';

export const setDefaultLanguage = (language) => {
  if (!localStorage.getItem('i18nextLng' && language)) {
    localStorage.setItem('i18nextLng', language);
  }
};

const getDetectedLocale = () => localStorage.getItem('i18nextLng').toUpperCase();

export const getInternationalizedResource = resourceKey => `${resourceKey}_${getDetectedLocale()}`;
export const getDefaultLanguageResource = resourceKey => `${resourceKey}_${defaultLocale.toUpperCase()}`;

export const translateFallback = (t, defaultKey, fallbackFn) => {
  const translation = t(defaultKey);
  if (translation === defaultKey) {
    return fallbackFn();
  }
  return translation;
};
